import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { environment } from '../../environments/environment';
import { LOGOUT_FLAG } from './auth-session.constants';
import { MeService } from './me.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private readonly msalService: MsalService,
    private readonly meService: MeService,
    private readonly storageService: StorageService
  ) {}

  logout(): void {
    this.storageService.remove('access_token');
    this.meService.reset();
    // Signing out is an explicit request to stay on the login screen: it stops the
    // automatic Microsoft handoff in AppComponent from signing the user back in.
    sessionStorage.setItem(LOGOUT_FLAG, '1');
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: environment.postLogoutRedirectUri
    }).subscribe();
  }
}
